module.exports = __webpack_public_path__ + "img/MAR.1299b3ff.svg";